import httpClient, { IRequest, IResponse } from '../../../apiService/httpClient';

/**
 * Response from Maccaferri Identity API (identity.maccaferri.com)
 * Contains real IsAdmin and Role values from the Identity Server's user database,
 * which may differ from JWT claim defaults.
 */
export interface IMaccaferriUserInfo {
    email: string;
    firstName: string;
    lastName: string;
    isAdmin: boolean;
    role: number;
}

/**
 * Direct provider for Maccaferri Identity API.
 * Calls identity.maccaferri.com/Identity/GetUser with cookie credentials.
 * This is the authoritative source for isAdmin — reads from the Identity Server's
 * user database rather than JWT claims.
 */
const MaccaferriIdentityProvider = () => {
    const _baseURL = process.env.REACT_APP_MACCAFERRI_IDENTITY_BASE_URL || 'https://identity.maccaferri.com';

    const _createRequest = <D>(_pathname: string, _data?: D): IRequest => {
        return {
            url: _pathname,
            baseURL: _baseURL,
            data: _data,
        };
    };

    const getUserAsync = async (): Promise<IResponse<IMaccaferriUserInfo>> => httpClient.getAsync(_createRequest('/IdentityV2/GetUser'));

    const logoutAsync = async (): Promise<IResponse<unknown>> => httpClient.getAsync(_createRequest('/Identity/Logout'));

    return {
        getUserAsync,
        logoutAsync,
    };
};

export default MaccaferriIdentityProvider();
